import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  FormGroup,
  Label,
  ModalFooter
} from 'reactstrap';

import SelectComponent from '@componentes/select/select.component';
import { atributosMedicoDetalhes } from '../../detalhes.utils';
import { etapasIndexEnum, tipoMedicoEnum } from '@common/util/defaultValues';
import * as commonActions from '@common/common.action';
import * as editorActions from '../../../editor/editor.action';
import WebapiCommon from '@util/webapi.common';

function ModalEditarMedico ({
  tipoMedico,
  medicoSelecionadoModal,
  setMedicoSelecionadoModal,
  modal,
  toggle,
  etapa,
  medicos
}) {
  const dispatch = useDispatch();
  const editor = useSelector(state => state.editor);
  const detalhes = useSelector(state => state.commonReducer.detalhes);

  const editarMedicoResponsavelLaudo = tipoMedico => {
    dispatch(commonActions.showFadeCarregando(true));
    let medicoId = medicoSelecionadoModal ? medicoSelecionadoModal.value : 0;
    let laudoTextoId = null;

    if (editor.idRtf) {
      laudoTextoId = editor.idRtf;
    }

    WebapiCommon.editarMedicoResponsavelLaudo(
      detalhes.laudo,
      medicoId,
      etapa.etapa,
      tipoMedico,
      laudoTextoId
    )
      .then(resp => {
        let detalhesUpdate = { ...detalhes };

        if (etapa.tab !== etapasIndexEnum.MATERIAL) {
          const atributos = atributosMedicoDetalhes.find(
            a => a.id === etapa.tab
          );
          detalhesUpdate[atributos[tipoMedico]] = medicoId;

          if (tipoMedico === tipoMedicoEnum.MEDICO) {
            dispatch(editorActions.ChangeMedExecutante(medicoId));
          } else {
            dispatch(editorActions.ChangeMedRevisor(medicoId));
          }

          if (!!resp.data && !!resp.data.alterouMedicoRevisaoAutomatica) {
            detalhesUpdate[atributos[tipoMedicoEnum.REVISOR]] = medicoId;
            dispatch(editorActions.ChangeMedRevisor(medicoId));
          }
        }
        toggle();
        dispatch(commonActions.atualizarDetalhes(detalhesUpdate));
        dispatch(commonActions.showFadeCarregando(false));
        const mensagem =
          tipoMedico === tipoMedicoEnum.MEDICO
            ? 'Médico responsável atualizado!'
            : 'Médico revisor atualizado!';
        dispatch(commonActions.showAlerta('sucesso', mensagem, 1500));
      })
      .catch(err => {
        dispatch(commonActions.showFadeCarregando(false));
        toggle();
        const mensagem = 'Houve um erro ao atualizar o Médico!';
        dispatch(commonActions.showAlerta('erro', mensagem, 3500));
        console.error(err);
      });
  };

  return (
    <Modal centered isOpen={modal} toggle={toggle}>
      <ModalHeader toggle={toggle}></ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label>
            {tipoMedico === tipoMedicoEnum.MEDICO
              ? 'Médico designado para este exame:'
              : 'Médico revisor designado para este exame:'}
          </Label>
          <SelectComponent
            placeholder={
              tipoMedico === tipoMedicoEnum.MEDICO
                ? 'Selecione médico para designar exame'
                : 'Selecione o médico para revisar este exame'
            }
            options={medicos}
            onChange={e => setMedicoSelecionadoModal(e)}
            value={medicoSelecionadoModal}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color='secondary' onClick={toggle}>
          Cancelar
        </Button>{' '}
        <Button
          color='primary'
          onClick={() => editarMedicoResponsavelLaudo(tipoMedico)}
        >
          Confirmar
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ModalEditarMedico;



// WEBPACK FOOTER //
// ./src/pages/laudo/detalhesExame/Medico/ModalEditar/index.js